import { Component, Input } from '@angular/core';
import { ButtonSizes, ButtonTypes } from '@models/app/types/Button';
import { LocalizeTextPipe } from '@shared/pipes/localize-text/localize-text.pipe';
import { ButtonLoaderComponent } from '../../loaders/button-loader/button-loader.component';
import { IconComponent } from '../../icon/icon.component';

@Component({
    selector: 'app-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss'],
    standalone: true,
    imports: [IconComponent, ButtonLoaderComponent, LocalizeTextPipe]
})
export class ButtonComponent {
  @Input() type = 'button';
  @Input() btnTxt = '';
  @Input() loading$ = false;
  @Input() icon = null;
  @Input() iconSpacing = '1';
  @Input() localizeTxt = false;
  @Input() class: string = null;
  @Input() lineHeight = 'normal';
  @Input() disabled = false;
  @Input() noBase = false;

  buttonTypeClass = 'btn-primary';
  buttonSizeClass = 'medium';

  @Input() set buttonSize(content: ButtonSizes) {
    this.buttonSizeClass = content;
  }

  @Input() outline = false;

  @Input() set buttonType(content: ButtonTypes | string) {
    switch (content) {
      case 'primary-inverted':
        this.buttonTypeClass = 'btn-primary-inverted';
        break;
      case 'primary':
        this.buttonTypeClass = 'btn-primary';
        break;
      case 'warning':
        this.buttonTypeClass = 'btn-warning';
        break;
      case 'danger':
        this.buttonTypeClass = 'btn-danger';
        break;
      case 'transparent':
        this.buttonTypeClass = 'btn-transparent';
        break;
      case 'grey':
        this.buttonTypeClass = 'btn-grey';
        break;
      case 'grey-with-border':
        this.buttonTypeClass = 'btn-grey-with-border';
        break;
      case 'none':
        this.buttonTypeClass = null;
        break;
    }
  }
}
